import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const RulesPage: React.FC = () => {
  const content = `🌸 Sistasouk Community-Regeln
Nr.
Regel
Beschreibung / Bedeutung
1
Respektvolles Miteinander
Alle Mitglieder behandeln sich freundlich, respektvoll und hilfsbereit. Beleidigungen, Diskriminierungen oder Drohungen sind verboten.
2
Nur für Frauen
Sistasouk ist eine geschützte Community ausschließlich für Frauen. Die Betreiberin entscheidet, wer Zugang erhält.
3
Ehrliche Angaben
Alle Angaben zu Artikeln, Preisen, Zustand und Versand müssen wahrheitsgemäß und vollständig sein. Täuschung oder Betrug führen zum Ausschluss.
4
Verbotene Inhalte
Keine illegalen, gefährlichen oder urheberrechtlich geschützten Produkte. Keine gefälschten Markenartikel, Medikamente, Waffen, Pornografie oder gestohlene Ware.
5
Verantwortung für eigene Inhalte
Jede Nutzerin ist für ihre hochgeladenen Bilder, Texte und Angebote allein verantwortlich. Die Betreiberin übernimmt keine Haftung.
6
Faire Kommunikation
In Chats, Bewertungen und Kommentaren gilt: sachlich bleiben, keine Beleidigungen, keine Falschbewertungen, kein Mobbing.
7
Sichere Transaktionen
Zahlungen erfolgen ausschließlich über PayPal oder andere freigegebene Dienste. Keine persönlichen Geldübergaben, kein Versand ohne Zahlung.
8
Privatverkäufe ohne Garantie
Alle Verkäufe erfolgen zwischen Privatpersonen. Es gibt keine Garantie, kein Widerrufsrecht und keine Rücknahme, außer die Verkäuferin bietet es freiwillig an.
9
Keine Rechteverletzung
Es dürfen keine Fotos, Texte oder Designs verwendet werden, an denen man keine eigenen Rechte besitzt. Urheberrechtsverletzungen führen zur Sperrung.
10
Sanktionen & Ausschluss
Die Betreiberin darf Mitglieder verwarnen, sperren oder dauerhaft ausschließen, wenn sie gegen die AGB, diese Regeln oder geltendes Recht verstoßen.`;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography component="div" sx={{ whiteSpace: 'pre-wrap', fontSize: '1rem', lineHeight: 1.75 }}>
          {content}
        </Typography>
      </Container>
    </Box>
  );
};

export default RulesPage;
